import React from 'react'
import { useRef, useState } from 'react'
import styles from '../componentsStyles/FormComponent.module.css'
import { FaPaperPlane } from "react-icons/fa";
import Loading from '../Loading.tsx';


const ContactForm = () => {
    const formRef = useRef(null);

    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    
    const handleContact = async(e)=>{
        e.preventDefault(e);
        
        setLoading(true);

        const formData = new FormData(e.currentTarget);
        const email = formData.get('email');
        const reason = formData.get('reason');
        const description = formData.get('description');

        if(!email || !reason){
            setLoading(false);
            setError(true);
            return;
        }

        const data ={
            email, reason, description
        }

        console.log(data);

        
        const url = 'https://email-handler2.vercel.app/api/resend?&&template=contact&&provider=resend';

        const res = await fetch(url,{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        console.log(res);


        if(res.ok){
            setSuccess(true);
            setLoading(false);
            formRef.current.reset();
        }

        if(!res.ok){
            console.log('erro');
            setError(true);
            setSuccess(false);
            setLoading(false);
        }

    }

    if(success){
        return(
            <div className={styles.formPage} >
                <div className={styles.successPopUp}>
                <p> Message sended, please wait for a response on the email informed, remember to check on the span box.</p>
                
                <button onClick={()=> setSuccess(current => !current)}> Close </button>
            </div>

            </div>
        )
    }
    if(error){
        return(
            <div className={styles.formPage} >
                <div className={styles.successPopUp}>
                <p> <span style={{color: 'red'}}>Message not sended</span>, check the input, empty input fields its not allowed!</p>
                
                <button onClick={()=> setError(current => !current)}> Close </button>
            </div>

            </div>
        )
    }

  return (
    
    <div className={styles.formPage} >
        <h3 className={styles.title}> Contact me</h3>
        <form ref ={formRef} onSubmit ={handleContact} className ={styles.form}>
           

            <p> Fill out the form below to contact me about a new product launch or to track the progress of products that you already ordered.
            </p>
            <small> Fields with * are mandatory</small>

            <label> Wy are you contacting me? *</label>
            <select name="reason" className={styles.selectField}>
                <option value="First contact"> First contact </option>
                <option value="Product">Regarding the progress of a requested project. (Include the order number in the description).</option>
                <option value="Other"> Another reason, please state in the description.</option>
            </select>

            <div className={styles.inputField}>
                <label > Your email adress: *</label>
                <input type="email" name="email"  />
            </div>
            
            

            <label className={styles.inputField}>
                Description:
                  
            </label>
            <textarea name="description" cols="30" rows="10">

            </textarea> 

            

            {
                loading ?
                <Loading message='Wait please..'/>
                :
                <button type='submit'>
                Send message
            </button>
            }
            
            <small> It takes me around 1 to 3 hours to respond to your contact, you will be contacted via the email provided on this form.</small>
            <small> The description area is not used to discuss specific details of the project, this can be done in future comunications.</small>
        </form>

        <div className={styles.imgContainer}>
            <FaPaperPlane className={styles.icon}/>
        </div>

    </div>
  )
}

export default ContactForm